import { Injectable } from '@angular/core';
import {Observable, ReplaySubject, Subject} from "rxjs";
import {first} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {Contract} from "../interface/contract";
import {ContractBalance} from "../interface/contract-balance";
import {ListResponse} from "../interface/response/list-response";
import {ContractInsuranceCompany} from "../interface/contract-insurance-company";
import {Invoice} from "../interface/invoice";
import {Uuid} from "../interface/response/uuid";

@Injectable({
  providedIn: 'root'
})
export class ContractBalanceService {

  public readonly contractBalanceListSubject: ReplaySubject<CountedAndPaginated<ContractBalance>> = new ReplaySubject<CountedAndPaginated<ContractBalance>>(1);
  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
  ) { }
  public sendForm(formData: object, contractBalanceId?: string): Observable<any> {
    if (contractBalanceId) {
      return this.httpClient.put(`/rest/crm/contract-balance/${contractBalanceId}`, formData)
        .pipe(
          first()
        );
    } else {
      return this.httpClient.post('/rest/crm/contract-balance', formData)
        .pipe(
          first()
        );
    }
  }
  public loadList(
    page: number,
    pageSize: number,
    filters: object,
    sort?: {
      sortBy?: string,
      sortOrder?: string,
    },
    subject?: Subject<CountedAndPaginated<ContractBalance>>): void {
    this.httpClient.get(`/rest/crm/contract-balance?page=${page + 1}&pageSize=${pageSize}&sortBy=${sort.sortBy ?? ''}&sortOrder=${sort.sortOrder ?? ''}&` + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<ContractBalance>) => {
        if (subject) {
          subject.next(result);
        } else {
          this.contractBalanceListSubject.next(result);
        }
      });
  }
  public get(contractBalanceId: string): Observable<ContractBalance> {
    return this.httpClient.get(`/rest/crm/contract-balance/${contractBalanceId}`)
      .pipe(first()) as Observable<ContractBalance>;
  }

  public downloadReport(filters: object,  sort?: { sortBy?: string, sortOrder?: string}): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/contract-balance/method/report?&sortBy=${sort.sortBy ?? ''}&sortOrder=${sort.sortOrder ?? ''}&` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }

  public downloadInvoiceReport(filters: object,  sort?: { sortBy?: string, sortOrder?: string}): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/contract-balance/method/invoice/report?&sortBy=${sort.sortBy ?? ''}&sortOrder=${sort.sortOrder ?? ''}&` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }
}
